import { render, staticRenderFns } from "./afterZixun2.vue?vue&type=template&id=6287b278&scoped=true"
import script from "./afterZixun2.vue?vue&type=script&lang=js"
export * from "./afterZixun2.vue?vue&type=script&lang=js"
import style0 from "./afterZixun2.vue?vue&type=style&index=0&id=6287b278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287b278",
  null
  
)

export default component.exports